import { REHYDRATE } from "redux-persist";
import update from "immutability-helper";
import { ANY_FIELD_UPDATE, NESTED_RECORD_ADD, updatedObject } from "actions/formActions";
import {
    SUPPLIER_MANAGER_INIT,
    SUPPLIER_MANAGER_ADD_TAGS_DIALOG_INIT,
    SUPPLIER_LIST_TAB_CHANGE,
    SELECT_SUPPLIER,
    SELECT_ALL_SUPPLIERS,
    NEW_FILTER_ADD,
    FILTER_REMOVE,
    FILTERS_CLEAR,
    SUPPLIER_FAVORITE_TOGGLE_BEGIN,
    SUPPLIER_FAVORITE_TOGGLE_SUCCESS,
    SUPPLIER_FAVORITE_TOGGLE_FAIL,
    SUPPLIERS_HANDLE_TAGS_BEGIN,
    SUPPLIERS_HANDLE_TAGS_SUCCESS,
    SUPPLIERS_HANDLE_TAGS_FAIL,
    SUPPLIER_MESSAGE_SEND_BEGIN,
    SUPPLIER_MESSAGE_SEND_SUCCESS,
    SUPPLIER_MESSAGE_SEND_RESET,
    SELECTED_SUPPLIERS_RESET,
    SUPPLIER_MANAGER_RESET,
    SupplierTypes,
} from "./types";

import INITIAL_STATE from "./state";

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case REHYDRATE:
            return state;

        case ANY_FIELD_UPDATE:
            if (action.storeName !== "supplierManager") return state;

            return {
                ...state,
                data: updatedObject(state.data, action.accessPath, action.newVal),
            };

        case NESTED_RECORD_ADD:
            if (action.storeName !== "supplierManager") return state;

            return update(state, {
                data: { filters: { cities: { values: { $push: [action.data] } } } },
            });

        case SUPPLIER_MANAGER_INIT:
            return update(INITIAL_STATE, { data: { filters: { $set: state.data.filters } } });

        case SUPPLIER_MANAGER_ADD_TAGS_DIALOG_INIT:
            return update(state, { data: { selectedTags: { $set: action.tags } } });

        case SUPPLIER_LIST_TAB_CHANGE:
            return update(state, {
                data: {
                    currTab: { $set: action.currTab },
                    selectedSuppliers: { $set: INITIAL_STATE.data.selectedSuppliers },
                },
            });

        case SELECT_SUPPLIER:
            if (!action.checked) {
                const { id } = action.supplier;
                const selectedIds = state.data.selectedSuppliers.map(
                    selectedSupplier => selectedSupplier.id
                );
                const itemIdx = selectedIds.indexOf(id);
                if (itemIdx > -1) {
                    return update(state, {
                        data: { selectedSuppliers: { $splice: [[itemIdx, 1]] } },
                    });
                }
                return state;
                // eslint-disable-next-line no-else-return
            } else {
                return update(state, { data: { selectedSuppliers: { $push: [action.supplier] } } });
            }

        case SELECT_ALL_SUPPLIERS:
            if (state.data.selectedSuppliers.length > 0) {
                return update(state, {
                    data: { selectedSuppliers: { $set: INITIAL_STATE.data.selectedSuppliers } },
                });
            }
            return update(state, { data: { selectedSuppliers: { $set: action.suppliers } } });

        case NEW_FILTER_ADD:
            return update(state, {
                data: { filters: { [action.filter]: { values: { $push: [""] } } } },
            });

        case FILTER_REMOVE:
            return update(state, {
                data: { filters: { [action.filter]: { values: { $splice: [[action.idx, 1]] } } } },
            });

        case FILTERS_CLEAR:
            return update(state, { data: { filters: { $set: INITIAL_STATE.data.filters } } });

        case SELECTED_SUPPLIERS_RESET:
            return update(state, {
                data: {
                    selectedSuppliers: { $set: INITIAL_STATE.data.selectedSuppliers },
                    selectedTags: { $set: INITIAL_STATE.data.selectedTags },
                },
            });

        case SUPPLIER_FAVORITE_TOGGLE_BEGIN:
            return { ...state, status: "handling" };

        case SUPPLIER_FAVORITE_TOGGLE_SUCCESS:
            return { ...state, status: "success" };

        case SUPPLIER_FAVORITE_TOGGLE_FAIL:
            return { ...state, status: "failed", error: action.error };

        case SUPPLIERS_HANDLE_TAGS_BEGIN:
            return { ...state, status: "handling" };

        case SUPPLIERS_HANDLE_TAGS_SUCCESS:
            return { ...state, status: "success" };

        case SUPPLIERS_HANDLE_TAGS_FAIL:
            return { ...state, status: "failed", error: action.error };

        case SUPPLIER_MESSAGE_SEND_BEGIN:
            return {
                ...state,
                data: {
                    ...state.data,
                    messageSent: true,
                },
                status: "handling",
            };

        case SUPPLIER_MESSAGE_SEND_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    messageSent: true,
                },
                status: "success",
            };

        case SUPPLIER_MESSAGE_SEND_RESET:
            return {
                ...state,
                data: {
                    ...state.data,
                    messageSent: false,
                },
                status: INITIAL_STATE.status,
            };
        // UPDATE_SUPPLIERS
        case SupplierTypes.UPDATE_SUPPLIERS.LOADING:
            return {
                ...state,
                updateSuppliers: {
                    loading: true,
                    success: false,
                    error: null,
                }
            };
        case SupplierTypes.UPDATE_SUPPLIERS.SUCCESS:
            return {
                ...state,
                updateSuppliers: {
                    loading: false,
                    success: true,
                    error: null,
                }
            };
        case SupplierTypes.UPDATE_SUPPLIERS.ERROR:
            return {
                ...state,
                updateSuppliers: {
                    loading: false,
                    success: false,
                    error: action.payload,
                }
            };

        case SUPPLIER_MANAGER_RESET:
            return INITIAL_STATE;

        default:
            return state;
    }
};
